/* eslint-disable no-trailing-spaces */
import React from 'react';
import { Box } from '@mui/material';
import './shimmer.scss';

function BaseShimmer({ 
  width = '100%', 
  height = '20px', 
  borderRadius = '4px',
  className = '',
  style = {},
  variant = 'rectangular', // rectangular, circular, text
}) {
  const getVariantClass = () => {
    switch (variant) {
      case 'circular':
        return 'shimmer-circular';
      case 'text':
        return 'shimmer-text';
      default:
        return 'shimmer-rectangular';
    }
  };

  return (
    <Box
      className={`shimmer-base ${getVariantClass()} ${className}`}
      sx={{
        width,
        height,
        borderRadius: variant === 'circular' ? '50%' : borderRadius,
        ...style,
      }}
    />
  );
}

export default BaseShimmer;
